// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--y6rWQ","text":"text--zvgtV","btn":"btn--ptRrj","result":"result--l6PKx"};